import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const PaymentTypeCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Payment gateway",
    cell: (row) => {
      return (row?.paymentGateways || []).length
        ? Array.from(row?.paymentGateways || []).join(", ")
        : "";
    },
  };
